import { Component, OnInit, inject } from '@angular/core';
import { UserMenuGroup } from 'src/app/models/admin-user-menu/user-menu-control.model';
import { LoginService } from 'src/app/service/login.service';
import { SharedFunctionService } from 'src/app/service/shared.function.service';
import { UserMenuService } from 'src/app/service/user.menu.service';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [NgClass, MatButton, RouterLink],
})
export class HomeComponent implements OnInit {
  loginService = inject(LoginService);
  private userMenuService = inject(UserMenuService);
  private sharedFunction = inject(SharedFunctionService);

  isDevMode: boolean = false;
  adminUserMenuGroup: UserMenuGroup[];

  ngOnInit() {
    this.loginService.checkLoginStatus();
    this.isDevMode = this.sharedFunction.isQaSite();
    this.adminUserMenuGroup = this.userMenuService.getLoginUserMenuGroups();
  }
}
